import { forwardRef, useMemo } from 'react';

import { useViewportHeight } from 'src/common/hooks/useViewportHeight';
import { cn } from 'src/common/utils';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const ViewportHeightContainer = forwardRef<HTMLDivElement, Props>(
  function ViewportHeightContainer({ className, style, ...rest }, ref) {
    const supportsDvh = useMemo(
      () =>
        typeof window !== 'undefined' &&
        typeof window.CSS !== 'undefined' &&
        !!window.CSS.supports?.('height', '100dvh'),
      [],
    );

    const measuredHeight = useViewportHeight();

    // dvh tracks the browser chrome collapse but ignores the on-screen
    // keyboard, so it never leaves a stale short shell. Fall back to a
    // measured pixel height on browsers without dvh support.
    const height = supportsDvh
      ? '100dvh'
      : measuredHeight
      ? `${measuredHeight}px`
      : '100vh';

    return (
      <div
        ref={ref}
        className={cn(className)}
        style={{ ...style, height }}
        {...rest}
      />
    );
  },
);
